<template>
  <dara-single-content-layout container-size="lg">
    <template v-if="hasDepartment" #content>
      <dara-header>
        {{ $t('editing-department') }}
      </dara-header>
      <dara-p class="dara-u-text--medium">
        {{ $t('editing-department-info1') }}<br>
        {{ $t('editing-department-info2') }}
      </dara-p>
      <dara-department-edit-inputs @save="saveDepartment" />
    </template>
  </dara-single-content-layout>
</template>

<script>
import { toastError } from '@/services/toastService';
import { goToListDepartments } from '@/modules/my-space/my-space.routes';
import { goHistoryBack } from '@/router/route.service';
import { saveDepartment, getDepartmentById } from '@/modules/department/department.service';
import { translate } from '@/services/translate.service';
import { USERS_ROLES } from '@/modules/user/user.constants';
import { getters } from '@/modules/user/user.store';
import { goToForbiddenDepartment } from '@/modules/department/department.routes';

import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';
import DaraDepartmentEditInputs from '@/modules/department/components/DepartmentEditInputs.vue';

export default {
  name: 'DaraDepartmentEditPage',
  components: {
    DaraSingleContentLayout,
    DaraDepartmentEditInputs,
  },
  provide() {
    const departmentEditVm = {};
    Object.defineProperty(departmentEditVm, 'department', {
      get: () => this.department,
    });
    return { departmentEditVm };
  },
  data() {
    return {
      user: getters.getUser(),
      department: null,
    };
  },
  computed: {
    id() {
      return this.$route.params?.id;
    },
    hasDepartment() {
      return !!this.department?.id;
    },
  },
  mounted() {
    if (this.user.permission < USERS_ROLES.ADMIN) {
      goToForbiddenDepartment(this.$router);
    } else {
      this.fetchDepartment();
    }
  },
  methods: {
    goHistoryBack,
    fetchDepartment() {
      if (this.department) return;
      getDepartmentById(this.id)
        .then(data => {
          this.department = data;
        })
        .catch(() => {
          toastError(`${translate('error-on-fetching-department')}`);
          this.department = null;
        });
    },
    saveDepartment() {
      saveDepartment(this.department)
        .then(() => {
          goToListDepartments(this.$router);
        })
        .catch(err => {
          if (err.response.status === 400 && err.response.data.errors[0].field === 'name' && err.response.data.errors[0].validation === 'unique') {
            toastError(translate('the-company-already-has-a-department-with-this-name'));
          } else if (err.response.data.errors.includes('value too long')) {
            toastError(translate('the-department-description-is-too-long'));
          } else {
            toastError(translate('error-on-saving-department'));
          }
        });
    },
  },
};
</script>
